// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2tFLe","right":"Footer_right__2JJD0","buttons":"Footer_buttons__2aEZh"};